import React, { FC } from 'react';
import { Flex, Tag } from '@duxton-web/ui';

import { assignByDomainMap } from '../../../RolloutTab/RolloutEditor/RolloutBlock/constants';
import { DIFF_SHOWFOR, DiffShowFor_Keys } from './RolloutDiffUtils';
import Service from '@/lib/App';
import { Constraint, Rollout, RolloutTarget } from '@/lib/PlannerDTOs';
import FullDivider from '@/pages/ExperimentFormV2/common/FullDivider';

interface OwnProps {
  domain: string;
  baseRollout: Rollout;
  baseTarget: RolloutTarget;
  compareRollout: Rollout;
  compareTarget: RolloutTarget;
  showFor: (typeof DIFF_SHOWFOR)[DiffShowFor_Keys];
  compact: boolean;
}

const RolloutDiffConstraintValue: FC<OwnProps> = ({
  domain,
  baseRollout,
  baseTarget,
  compareRollout,
  compareTarget,
  showFor,
  compact,
}) => {
  const getAssignBy = (rollout: Rollout) => {
    if (Service.cache.isFeatureFlagOn('domainless')) {
      return rollout.assignBy;
    }
    return assignByDomainMap[domain] || 'pax';
  };

  const findSliderConstraintIndex = (
    rollout: Rollout,
    rolloutTarget: RolloutTarget,
  ) => {
    let index: number =
      rolloutTarget?.constraints?.findIndex((constraint) =>
        isSliderConstraint(rollout, constraint),
      ) || 0;
    return index;
  };

  const isSliderConstraint = (rollout: Rollout, constraint: Constraint) => {
    return constraint.target === getAssignBy(rollout) && constraint.op === '/';
  };

  const findSliderConstraintValue = (
    rolloutTarget: RolloutTarget,
    index: number,
  ): number => {
    if (index == -1 || !rolloutTarget?.constraints) {
      return 1;
    }
    return +rolloutTarget?.constraints[index]?.value;
  };

  const baseConstraintIndex = findSliderConstraintIndex(
    baseRollout,
    baseTarget,
  );
  const baseConstraintValue = findSliderConstraintValue(
    baseTarget,
    baseConstraintIndex,
  );

  const compareConstraintIndex = findSliderConstraintIndex(
    compareRollout,
    compareTarget,
  );
  const compareConstraintValue = findSliderConstraintValue(
    compareTarget,
    compareConstraintIndex,
  );

  let classname: string;

  if (baseConstraintValue !== compareConstraintValue)
    classname = `rollout-diff-tag-secondary rollout-target-value-${
      showFor === DIFF_SHOWFOR.BEFORE ? 'deleted' : 'added'
    } ${compact ? 'rollout-diff-tag-v2-compact' : ''}`;

  return (
    <Flex gap={8} vertical>
      <FullDivider
        orientation="left"
        orientationMargin={0}
        style={{ margin: 0 }}
      >
        <Tag
          color="#3D3D3D"
          style={{ margin: 0, borderRadius: 8, fontSize: 12 }}
        >
          Rollout Percentage
        </Tag>
      </FullDivider>
      <div
        className={classname}
        style={{
          border: '1px solid #e8e8e8',
          borderRadius: 12,
          padding: 8,
        }}
      >
        {baseConstraintValue * 100}%
      </div>
    </Flex>
  );
};

export default RolloutDiffConstraintValue;
